<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <!-- <span class="masge">当前共有{{ total }}个{{this.route.menuName}}</span> -->
      </div>
      <div class="top">
        <el-button type="primary" @click="addEvt">新增</el-button>
        <div>
          <span>年度：</span>
          <el-select v-model="query.keyWord" placeholder="请选择" @change="yearEvt">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button style="margin-left: 20px" type="primary">查询</el-button>
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        stripe
        :header-cell-style="{ background: '#DDEBFF' }"
      >
        <el-table-column prop="period" label="会计期间" width="150"> </el-table-column>
        <el-table-column prop="start" label="开始日期" width="">
          <template slot-scope="scope">
            <el-date-picker
              v-if="scope.row.edit == true"
              v-model="scope.row.startDate"
              disabled
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
            <span v-else>{{ scope.row.startDate }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="end" label="结束日期" width="">
          <template slot-scope="scope">
            <el-date-picker
              v-if="scope.row.edit == true"
              v-model="scope.row.endDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
            <span v-else>{{ scope.row.endDate }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="结存状态" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">未结存</span>
            <span v-else>已结存</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              v-if="
                (!scope.row.edit || scope.row.edit == false) && scope.row.editShow == true
              "
              type="text"
              size="small"
              @click="editEvt(scope.row)"
              >编辑</el-button
            >
            <div
              v-if="scope.row.edit == true && scope.row.editShow == true"
              class="editBox"
            >
              <i @click="closeEvt(scope.row)" class="el-icon-close"></i>
              <i @click="checkEvt(scope.row, scope.$index)" class="el-icon-check"></i>
            </div>
            <el-popconfirm
              v-if="scope.row.state == 1 && scope.row.editShow !== true"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon="el-icon-info"
              icon-color="#f77d00"
              @confirm="confirmEvt(scope.row)"
              :title="`是否确定取消${scope.row.period}期间的结存？`"
            >
              <el-button type="text" size="small" slot="reference">取消结存</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <div class="paging">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="query.pageIndex"
          :page-size="query.pageSize"
          :pager-count="5"
          :total="messagePageTotal"
          @current-change="messagePageChange"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      title="创建会计期间"
      :visible.sync="dialogTableVisible"
      @close="closeCreateEvt"
    >
      <div class="createBox">
        <el-input
          v-model="createInput"
          v-if="tableData.length == 0"
          style="width: 300px; margin-right: 10px"
          placeholder="请输入年份，如 2020"
        ></el-input>
        <el-button type="primary" v-if="tableData.length == 0" @click="createEvt"
          >创建</el-button
        >
        <el-button type="primary" v-if="tableData.length !== 0" @click="createNextEvt"
          >创建下一年度期间</el-button
        >
      </div>
      <el-table
        :data="createData"
        border
        style="width: 100%"
        height="500"
        stripe
        :header-cell-style="{ background: '#DDEBFF' }"
      >
        <el-table-column prop="month" label="会计期间" width="150"> </el-table-column>
        <el-table-column prop="start" label="开始日期" width="">
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.start"
              :disabled="scope.row.disabled"
              type="date"
              @focus="FocusEvt(scope.$index)"
              @change="startTimeEvt"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column prop="end" label="结束日期" width="">
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.end"
              @focus="FocusEvt(scope.$index)"
              @change="endTimeEvt"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button @click="submitEvt" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetFiscalPeriodLastAnnual,
  GetFiscalPeriods,
  CancelFiscalPeriod,
  SaveFiscalPeriods,
  SaveFiscalPeriod,
} from "@/api";
export default {
  mixins: [GetDataMixin],
  data() {
    return {
      input: "",
      tableData: [],
      createData: [],
      options: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "2030",
          value: 2030,
        },
        {
          label: "2029",
          value: 2029,
        },
        {
          label: "2028",
          value: 2028,
        },
        {
          label: "2027",
          value: 2027,
        },
        {
          label: "2026",
          value: 2026,
        },
        {
          label: "2025",
          value: 2025,
        },
        {
          label: "2024",
          value: 2024,
        },
        {
          label: "2023",
          value: 2023,
        },
        {
          label: "2022",
          value: 2022,
        },
        {
          label: "2021",
          value: 2021,
        },
        {
          label: "2020",
          value: 2020,
        },
      ],
      value: "",
      messagePageTotal: 0,
      query: {
        keyWord: "",
        pageIndex: 1,
        pageSize: 12,
      },
      dialogTableVisible: false,
      createInput: "",
      createIndex: null,
      Year: null,
      y: 1,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getYear(year) {
      let arr = [];
      this.options.forEach((res) => {
        if (res.value <= year) {
          arr.push(res);
        }
      });
      this.options = arr;
    },
    //
    getList() {
      GetFiscalPeriods(this.query).then((res) => {
        this.tableData = res.returnData.data.map((item) => {
          if (
            item.period.split("-")[0] > new Date().getFullYear() ||
            (item.period.split("-")[0] == new Date().getFullYear() &&
              item.period.split("-")[1] >= new Date().getMonth() + 1)
          ) {
            item.editShow = true;
          }
          item.startDate = item.startDate.split("T")[0];
          item.endDate = item.endDate.split("T")[0];
          return item;
        });
        if (this.y == 1) {
          this.getYear(res.returnData.data[0].annual);
          this.y++;
        }
        this.messagePageTotal = res.returnData.totalCount;
      });
    },
    // 分页
    messagePageChange(val) {
      this.query.pageIndex = val;
      this.getList();
    },
    // 编辑
    editEvt(row) {
      this.tableData = this.tableData.map((res) => {
        if (res.id == row.id) {
          res.edit = true;
        }
        return res;
      });
    },
    // 关闭编辑
    closeEvt(row) {
      this.tableData = this.tableData.map((res) => {
        if (res.id == row.id) {
          res.edit = false;
        }
        return res;
      });
    },
    //打开新增弹窗
    addEvt() {
      this.dialogTableVisible = true;
    },
    //创建
    createEvt() {
      console.log(this.createInput.substr(0, 2), this.createInput);
      if (!this.createInput) {
        this.$message({
          message: "请先输入年度",
          type: "warning",
        });
        return;
      } else if (this.createInput.substr(0, 2) !== "20") {
        this.$message({
          message: "输入的年度不合法",
          type: "warning",
        });
        return;
      } else if (this.createInput.length !== 4) {
        this.$message({
          message: "请先输入合法年度",
          type: "warning",
        });
        return;
      }
      this.Year = new Date(parseInt(this.createInput), 0).getFullYear();
      let arr = [];
      for (let i = 0; i < 12; i++) {
        arr.push({
          id: i,
          month: this.Year + "-" + (i + 1),
          start: "",
          end: "",
        });
      }
      this.createData = arr;
    },
    //创建下一年
    createNextEvt() {
      if (this.createData.length != 0) {
        return;
      }
      this.createList({});
    },
    //创建列表
    createList(data) {
      GetFiscalPeriods(data).then((res) => {
        let val = res.returnData.data[0].endDate.split("T")[0];
        this.Year = res.returnData.data[0].annual + 1;
        let time = Date.parse(val);
        let next = new Date(parseInt(1000 * 60 * 60 * 24 + time))
          .toLocaleString()
          .replace(/\//g, "-");
        let arr = [];
        for (let i = 0; i < 12; i++) {
          if (i == 0) {
            arr.push({
              month: this.Year + "-" + (i + 1),
              start: next,
              end: this.Year + "-" + (i + 1) + "-" + "1",
              disabled: true,
            });
          } else {
            arr.push({
              month: this.Year + "-" + (i + 1),
              start: this.Year + "-" + (i + 1) + "-" + "1",
              end: this.Year + "-" + (i + 1) + "-" + "1",
            });
          }
        }
        this.createData = arr;
      });
    },
    //环保新增弹窗
    closeCreateEvt() {
      this.createInput = "";
      this.createData = [];
    },
    // 获取当前点击的月份
    FocusEvt(index) {
      this.createIndex = index;
    },
    //
    yearEvt() {
      this.query.pageIndex = 1;
      this.getList();
    },
    //
    endTimeEvt(val) {
      let time = Date.parse(val);
      let next = new Date(parseInt(1000 * 60 * 60 * 24 + time))
        .toLocaleString()
        .replace(/\//g, "-");
      if (this.createIndex == 11) {
        return;
      }
      let index = this.createIndex + 1;
      this.createData[index].start = next;
    },
    startTimeEvt(val) {
      let time = Date.parse(val);
      let next = new Date(parseInt(time - 1000 * 60 * 60 * 24))
        .toLocaleString()
        .replace(/\//g, "-");
      if (this.createIndex == 0) {
        return;
      }
      let index = this.createIndex - 1;
      this.createData[index].end = next;
    },
    // 确定提交
    submitEvt() {
      let yes = true;
      this.createData.forEach((item, index) => {
        if (
          item.start == "" ||
          item.end == "" ||
          item.start == null ||
          item.end == null
        ) {
          yes = false;
          this.$message({
            message: "请填写完整后再提交",
            type: "warning",
          });
          throw new Error("错误");
        }
        if (index < 11) {
          console.log(index + 1);
          if (
            Date.parse(this.createData[index + 1].start) - Date.parse(item.end) !==
            86400000
          ) {
            yes = false;
            this.$message({
              message: `第${index + 1}行的开始结束时间没有连续`,
              type: "warning",
            });
            throw new Error("错误");
          }
        } else {
          if (
            Date.parse(item.start) - Date.parse(this.createData[index - 1].end) !==
            86400000
          ) {
            yes = false;
            this.$message({
              message: `第${index + 1}行的开始结束时间没有连续`,
              type: "warning",
            });
            throw new Error("错误");
          }
        }
      });
      if (yes) {
        let data = [];
        this.createData.forEach((item, index) => {
          data.push({
            annual: this.Year,
            period: item.month,
            month: index + 1,
            startDate: item.start,
            endDate: item.end,
          });
        });

        SaveFiscalPeriods(data).then((res) => {
          this.dialogTableVisible = false;
          this.getList();
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      }
    },
    // 修改确定
    checkEvt(row, index) {
      SaveFiscalPeriod(row).then((res) => {
        this.$nextTick(() => {
          this.tableData = this.tableData.map((res, i) => {
            if (index == i) {
              res.edit = false;
            }
            return res;
          });
        });
        this.getList();
      });
      // if(index==0){
      //  await SaveFiscalPeriod(data).then(res=>{
      //   })
      // }else{
      //  await SaveFiscalPeriod(data).then(res=>{
      //   })
      //   data.id = this.tableData[index - 1].id
      //   data.annual = this.tableData[index - 1].period.split('-')[0],
      //   data.period = this.tableData[index - 1].period
      //   let time = Date.parse(this.tableData[index].endDate)
      //   let next =  new Date(parseInt((1000*60*60*24) + time)).toLocaleString().replace(/\//g, "-");
      //   console.log(next);
      //   data.startDate = next
      //   data.endDate = this.tableData[index - 1].endDate
      //  await SaveFiscalPeriod(data).then(res=>{
      //   })
      // }
    },
    // 确定结存
    confirmEvt(row) {
      CancelFiscalPeriod({ id: row.id }).then((res) => {
        this.getList();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.editBox {
  font-size: 15px;
  display: flex;
  justify-content: space-around;

  .el-icon-close {
    color: red;
  }

  .el-icon-check {
    color: green;
  }
}

.createBox {
  display: flex;
  margin-bottom: 20px;
}

.paging {
  display: flex;
  padding: 15px;
  flex-direction: row-reverse;
}
</style>
